import { IntlShape } from 'react-intl';

import { sharedMessages } from '@app/translations';
import {
  HoldDto,
  ITEM_STATUS,
  ItemStatusData,
  STATUS_ICON,
} from '@app/constants';

import { HOLD_STATUS_MESSAGE_MAP } from './getItemStatusData';

export const getRequestsStatusesData = (
  holdsData: HoldDto[],
  intl: IntlShape,
  selectConfiguredOption
): ItemStatusData[] =>
  holdsData.map(({ item, status, queuePosition, requestId }) => ({
    holdId: requestId,
    instanceId: item.instanceId,
    itemId: item.itemId,
    icon: STATUS_ICON[ITEM_STATUS.onHold],
    status: ITEM_STATUS.onHold,
    statusMessage: intl.$t(HOLD_STATUS_MESSAGE_MAP[status], {
      value: queuePosition,
    }),
    actionButtonText: selectConfiguredOption(
      intl.$t(sharedMessages.removeRequest),
      intl.$t(sharedMessages.removeHold)
    ),
    isVirtualItem: item.virtual,
  }));
